import { ParagraphSM, TitleXS } from '@/atoms/Text'

interface TorchStepsCardProps {
  icon: React.ReactNode
  title: string
  description: string | string[]
  descriptionList?: string[]
}

export const TorchStepsCard: React.FC<TorchStepsCardProps> = ({ icon, title, description, descriptionList }) => {
  return (
    <div className="flex min-w-[280px] flex-1 flex-col rounded-2xl bg-core-gray-900 px-6 py-[16px] md:items-start md:px-8 md:py-6 xl:gap-4 xl:p-10 se:px-4 se:py-3">
      <div className="flex flex-row items-center gap-3 lg:flex-col lg:items-start lg:gap-10 se:gap-2">
        {icon}
        <TitleXS
          className="se:photon-caption-md md:photon-title-md xl:photon-title-lg w-full"
          color="white"
          weight="bold"
        >
          {title}
        </TitleXS>
      </div>
      {Array.isArray(description) ? (
        description.map((item, index) => (
          <ParagraphSM key={index} className="inline py-2" color="core-gray-500" weight="normal">
            {item}
          </ParagraphSM>
        ))
      ) : (
        <ParagraphSM className="se:photon-caption-sm xl:photon-paragraph-md" color="core-gray-500" weight="normal">
          {description}
        </ParagraphSM>
      )}
      {descriptionList && (
        <ul className="se:photon-caption-sm xl:photon-paragraph-md list-inside list-disc space-y-1">
          {descriptionList.map((item, index) => (
            <li key={index} className="flex items-start">
              <span className="mr-3 mt-3 h-1 w-1 shrink-0 rounded-full bg-core-gray-400"></span>
              <ParagraphSM className="inline" color="core-gray-500" weight="normal">
                {item}
              </ParagraphSM>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
